// AUTOGENERATED
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCoupons$dInternal$dTypes$dCouponData from "../Restaumatic.Coupons.Internal.Types.CouponData/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq1 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.eqCouponData)(Data$dEq.eqUnit).eq)();
const countIsSymbol = {reflectSymbol: () => "count"};
const couponDataIsSymbol = {reflectSymbol: () => "couponData"};
const promotionNameIsSymbol = {reflectSymbol: () => "promotionName"};
const UserLoyaltyIsSymbol = {reflectSymbol: () => "UserLoyalty"};
const UserLoyalty = x => x;
const newtypeUserLoyalty_ = {Coercible0: () => {}};
const hasFieldUserLoyalty = dictHasField => dictHasField;
const eqUserLoyalty = {eq: x => y => x.count === y.count && eq1(x.couponData)(y.couponData) && x.promotionName === y.promotionName};
const genericUserLoyalty = {to: x => x, from: x => x};
const showUserLoyalty = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.showCouponData);
      return {
        genericShowArgs: v => [
          "{ count: " + Data$dShow.showIntImpl(v.count) + ", couponData: " + $0.show(v.couponData) + ", promotionName: " + Data$dShow.showStringImpl(v.promotionName) + " " + "}"
        ]
      };
    })())(UserLoyaltyIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeUserLoyalty = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(countIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(couponDataIsSymbol)(Unscramble.decodeSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.unscrambleDecodeCouponData)(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.ordCouponData))(Unscramble.decodeRecordCons(promotionNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeUserLoyalty = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericUserLoyalty)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(UserLoyaltyIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(promotionNameIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(couponDataIsSymbol)((() => {
      const encode1 = Data$dSet$dSerialized.encodeSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.encodeCouponData).encode;
      return {encodeWithOptions: v => encode1};
    })()))(countIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeUserLoyalty = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericUserLoyalty)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(UserLoyaltyIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(promotionNameIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.readString
  })())(couponDataIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dSet$dSerialized.decodeSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.ordCouponData)(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.decodeCouponData).decode;
    return {decodeWithOptions: v => decode2};
  })())())(countIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  UserLoyalty,
  UserLoyaltyIsSymbol,
  countIsSymbol,
  couponDataIsSymbol,
  decodeUserLoyalty,
  encodeUserLoyalty,
  eq1,
  eqUserLoyalty,
  genericUserLoyalty,
  hasFieldUserLoyalty,
  newtypeUserLoyalty_,
  promotionNameIsSymbol,
  showUserLoyalty,
  unscrambleDecodeUserLoyalty
};
